exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".successTextColor[data-v-fa883808]{color:var(--tagSuccessText)}.infoText[data-v-fa883808]{color:var(--tagInfoText)}", ""]);

// exports
